<template>
  <button
    class="bg-white text-darkGreen flex items-center justify-between flex-row fill-darkGreen border-1 border-lightGreen rounded-full px-7 py-2"
    @click="isOpen = !isOpen"
  >
    <span v-if="!isOpen" class="shrink-0 mr-2">
      {{ $texts('filter.mobileTitleOpen', 'Filter') }}
    </span>
    <span v-else class="shrink-0 mr-2">
      {{ $texts('filter.mobileTitleClose', 'Schliessen') }}
    </span>
    <svg
      id="uuid-0193a0d7-c511-44a1-8b53-560f2cf43b2b"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 28"
      height="28"
      class="shrink-0"
    >
      <path
        d="M7.07,5.12c-.41,0-.75.34-.75.75v16.26c0,.41.34.75.75.75s.75-.34.75-.75V5.87c0-.41-.34-.75-.75-.75Z"
        fill="currentColor"
      />
      <path
        d="M21.68,12.9v-7.03c0-.41-.34-.75-.75-.75s-.75.34-.75.75v10.28s0,0,0,0v5.98c0,.41.34.75.75.75s.75-.34.75-.75v-9.23s0,0,0,0Z"
        fill="currentColor"
      />
      <path
        d="M14,5.12c-.41,0-.75.34-.75.75v16.26c0,.41.34.75.75.75s.75-.34.75-.75V5.87c0-.41-.34-.75-.75-.75Z"
        fill="currentColor"
      />

      <circle
        cx="7.06"
        cy="12.74"
        r="2.29"
        fill="#fff"
        stroke="currentColor"
        stroke-width="1.5"
        :class="{
          'close-icon-left-forwards': isOpen,
          'close-icon-left-backwards': !isOpen,
        }"
      />
      <circle
        cx="14"
        cy="17.32"
        r="2.29"
        fill="#fff"
        stroke="currentColor"
        stroke-width="1.5"
        :class="{
          'close-icon-middle-forwards': isOpen,
          'close-icon-middle-backwards': !isOpen,
        }"
      />
      <circle
        cx="20.94"
        cy="10.61"
        r="2.29"
        fill="#fff"
        stroke="currentColor"
        stroke-width="1.5"
        :class="{
          'close-icon-right-forwards': isOpen,
          'close-icon-right-backwards': !isOpen,
        }"
      />
    </svg>
  </button>
</template>

<script lang="ts" setup>
const { $texts } = useNuxtApp()
const isOpen = defineModel<boolean>({
  default: false,
})

await renderPageDependencies()
</script>

<style>
@keyframes closeIconLeft {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(0, 4px);
  }
}

@keyframes closeIconMiddle {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, -7px);
  }
}

@keyframes closeIconRight {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, 7px);
  }
}

@keyframes closeIconLeftReverse {
  0% {
    transform: translate(0, 4px);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes closeIconMiddleReverse {
  0% {
    transform: translate(0, -7px);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes closeIconRightReverse {
  0% {
    transform: translate(0, 7px);
  }
  100% {
    transform: translate(0, 0);
  }
}

.close-icon-left-forwards {
  animation-name: closeIconLeft;
  animation-fill-mode: forwards;
  animation-duration: 250ms;
}

.close-icon-left-backwards {
  transform: translate(0, 0);
  animation-name: closeIconLeftReverse;
  animation-fill-mode: forwards;
  animation-duration: 250ms;
}

.close-icon-right-forwards {
  animation-name: closeIconRight;
  animation-fill-mode: forwards;
  animation-duration: 250ms;
}

.close-icon-right-backwards {
  transform: translate(0, 0);
  animation-name: closeIconRightReverse;
  animation-fill-mode: forwards;
  animation-duration: 250ms;
}

.close-icon-middle-forwards {
  animation-name: closeIconMiddle;
  animation-fill-mode: forwards;
  animation-duration: 250ms;
}

.close-icon-middle-backwards {
  opacity: 1;
  animation-name: closeIconMiddleReverse;
  animation-fill-mode: forwards;
  animation-duration: 250ms;
}
</style>
